import { IRadioButtonProps } from 'typings';

import { Input, Label, Text } from './styles';

export const RadioButton = ({
  children,
  className,
  ...inputAttributes
}: IRadioButtonProps) => (
  <Label className={className}>
    <Input type="radio" {...inputAttributes} />
    <Text>{children}</Text>
  </Label>
);
